import * as o from "react";
import m from "../lib/IconBase.es.js";
import e from "../defs/InstagramLogo.es.js";
const a = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(m, { ref: t, ...r, weights: e }));
a.displayName = "InstagramLogoIcon";
const c = a;
export {
  c as InstagramLogo,
  a as InstagramLogoIcon
};
